import { CheckCircle2, Star, Trash2 } from "lucide-react";

import { Button } from "~/components/ui/button";

interface StationActionButtonsProps {
  isDefault: boolean;
  onDelete: () => void;
  onSetDefault: () => void;
  setDefaultPending: boolean;
  onCancel: () => void;
  onSave: () => void;
  savePending: boolean;
  hasChanges: boolean;
}

export function StationActionButtons({
  isDefault,
  onDelete,
  onSetDefault,
  setDefaultPending,
  onCancel,
  onSave,
  savePending,
  hasChanges,
}: StationActionButtonsProps) {
  return (
    <div className="flex items-center justify-between pt-4">
      <div className="flex gap-2">
        {!isDefault && (
          <>
            <Button onClick={onDelete} variant="destructive">
              <Trash2 className="mr-2 h-4 w-4" />
              Delete
            </Button>
            <Button
              disabled={setDefaultPending}
              onClick={onSetDefault}
              variant="outline"
            >
              <Star className="mr-2 h-4 w-4" />
              Set as Default
            </Button>
          </>
        )}
      </div>
      <div className="flex gap-3">
        <Button onClick={onCancel} variant="outline">
          Cancel
        </Button>
        <Button disabled={savePending || !hasChanges} onClick={onSave}>
          <CheckCircle2 className="mr-2 h-4 w-4" />
          Save Changes
        </Button>
      </div>
    </div>
  );
}
